import React, { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { WaterIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { useStyles } from "../../useStyles";
import { InputLabel } from "@material-ui/core";
import { NumberInput } from "../core/NumberField";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";

export const IncreaseCurrentElectricBoilerForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, getFieldProps } = useFormModel<
        ChangeNames.INCREASE_CURRENT_ELECTRIC_BOILER
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<WaterIcon />}
                content={
                    <p className={classes.label}>
                        Elektrische Warmwasseraufbereitung (Durchlauferhitzer)
                    </p>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseCurrentElectricBoiler.value.installed}
                        {...getFieldProps("increaseCurrentElectricBoiler.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.increaseCurrentElectricBoiler.value.installed = checked;
                                values.increaseCurrentElectricBoiler.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseCurrentElectricBoiler.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.increaseCurrentElectricBoiler.value.demand.precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.increaseCurrentElectricBoiler.value.demand.unit}
                            value={values.increaseCurrentElectricBoiler.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.increaseCurrentElectricBoiler.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseCurrentElectricBoiler.error != null}
                        />
                        <br />
                        <FormControlLabel
                            style={{ marginBottom: 24 }}
                            isCheckBox={true}
                            control={
                                <Checkbox
                                    value="ja"
                                    checked={values.increaseCurrentElectricBoiler.value.notKnown}
                                    onChange={(event, checked) =>
                                        setValues(values => {
                                            values.increaseCurrentElectricBoiler.value.notKnown = checked;
                                        })
                                    }
                                />
                            }
                            label="Leistungswert nicht bekannt"
                            error={false}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
